import { Box, styled, Typography } from "@mui/material";

export const Styled = {
    Container: styled(Box)``,
    Name: styled(Typography)`
        color: ${props => props.theme.palette.primary.main};
        cursor: pointer;
    `,
};
